export type WarningIconProps = {
    height?: number | string;
    width?: number | string;
};

const WarningIcon = ({ height = 60, width = 64 }: WarningIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 64 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M27 50.75C27 51.4404 27.5598 52 28.25 52H35.75C36.4403 52 37 51.4404 37 50.75V43.25C37 42.5596 36.4403 42 35.75 42H28.25C27.5598 42 27 42.5596 27 43.25V50.75ZM29.5 44.5H34.5V49.5H29.5V44.5Z" fill="#A20107" />
            <path d="M28.25 37H35.75C36.4403 37 37 36.4404 37 35.75V17C37 16.3096 36.4403 15.75 35.75 15.75H28.25C27.5598 15.75 27 16.3096 27 17V35.75C27 36.4404 27.5598 37 28.25 37ZM29.5 18.25H34.5V34.5H29.5V18.25Z" fill="#A20107" />
            <path d="M32 59.5C32.6904 59.5 33.25 58.9404 33.25 58.25C33.25 57.5596 32.6904 57 32 57C31.3096 57 30.75 57.5596 30.75 58.25C30.75 58.9404 31.3096 59.5 32 59.5Z" fill="#A20107" />
            <path d="M38.0481 3.605C36.8446 1.38138 34.5271 0 32 0C29.4729 0 27.1554 1.38137 25.9556 3.59837L0.8275 49.354C0.286125 50.3519 0 51.483 0 52.625C0 56.4159 3.08413 59.5 6.875 59.5H26.375C27.0653 59.5 27.625 58.9404 27.625 58.25C27.625 57.5596 27.0653 57 26.375 57H6.875C4.46263 57 2.5 55.0374 2.5 52.625C2.5 51.8981 2.6815 51.1792 3.022 50.5518L28.1506 4.795C28.9167 3.37937 30.3918 2.5 32 2.5C33.6082 2.5 35.0833 3.37938 35.853 4.80175L60.975 50.5461C61.3185 51.1792 61.5 51.8981 61.5 52.625C61.5 55.0374 59.5374 57 57.125 57H37.625C36.9347 57 36.375 57.5596 36.375 58.25C36.375 58.9404 36.9347 59.5 37.625 59.5H57.125C60.9159 59.5 64 56.4159 64 52.625C64 51.483 63.7139 50.3519 63.1694 49.3484L38.0481 3.605Z" fill="#A20107" />
        </svg>
    );
};

export default WarningIcon;

